'use strict';



const confirmFormSubmit = require('./confirm-form-submit');



const confirmCancelLoanpartSale = $form => confirmFormSubmit($form, $form => {

	const { amount, loan } = $form.data();

	return `
		<h1 class='[  c-heading  c-heading--dark  ]  u-beta'>${loan}</h1>
		<p>Are you sure you wish to cancel the sale of your <strong>${amount}</strong>&nbsp;loan part? You will commence earning interest from the date it is cancelled. You will not earn interest for the period when it was for sale.</p>`;

});



module.exports = confirmCancelLoanpartSale;